document.addEventListener('DOMContentLoaded',()=>{
    const qtyEl = document.querySelector('input.quantity-selector__input');
    const minQty = parseInt(qtyEl.getAttribute('min')) || 1;
    qtyEl.removeAttribute('min');
    qtyEl.addEventListener('change',(e)=>{
        const currentQty = parseInt(e.target.value);
        if (currentQty < minQty){
            e.target.value = minQty;
        }
    })
})